<template>
  <AgentPermissionsModal
    :apps-loading="isLoading"
    :is-processing="isProcessing"
    :email="agent.email"
    :permissions.sync="permissions"
    :value="value"
    @close="close"
    @closed="updatePermissionsToTransformed"
    @submit="updatePermissions"
  />
</template>

<script>
import { APPS } from '@/store/types';

import AgentPermissionsModal from './AgentPermissionsModal';

import { Agents } from '@/api/api';

import {
  transformIncomingAgentPermissions,
  transformOutgoingAgentPermissions,
} from './agentTransformers';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AgentPermissionsModalWrapper',
  components: {
    AgentPermissionsModal,
  },
  props: {
    agent: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      isProcessing: false,
      permissions: {},
    };
  },
  computed: {
    ...mapGetters({
      apps: APPS,
    }),
  },
  watch: {
    'agent.permissions': {
      deep: true,
      immediate: true,
      handler() {
        this.updatePermissionsToTransformed();
      },
    },
  },
  created() {
    this.getApps();
  },
  methods: {
    ...mapActions({
      getAppsStore: APPS,
    }),
    updatePermissionsToTransformed() {
      this.permissions = transformIncomingAgentPermissions(
        this.agent.permissions,
        this.apps,
      );
    },
    getApps() {
      this.isLoading = true;

      return this.getAppsStore()
        .then(() => {
          this.updatePermissionsToTransformed();
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('input', false);
    },
    updatePermissions() {
      this.isProcessing = true;

      const normalizedPermissions = transformOutgoingAgentPermissions(
        this.permissions,
      );

      // @todo: move to api layer
      normalizedPermissions.general_permissions.advertisement = false;

      return Agents.patch(
        {
          id: this.agent.id,
        },
        normalizedPermissions,
      )
        .then(({ body: { agent: updatedAgentPermissions, message } }) => {
          this.$message.success(message);

          // tells the parent to update its agent prop value
          this.$emit('updateAgentPermissions', updatedAgentPermissions);

          this.close();
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
